// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"ffbc812f","133":"db1e141e","328":"ffbc812f","602":"db1e141e","694":"778d30b2","856":"420d24f0"}[chunkId] + ".chunk.css";
};